import { BOTONES } from '../../../../../componentes/botones';
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  IActivo,
  IConfigEventoUsuario,
  ICreateConfigEventoUsuario,
  IFilter,
  IGeoJSONPoint,
  IQueryParam,
  IReporteGenerico,
  IUsuario,
} from 'modelos/src';
import { Subscription, firstValueFrom } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { ConfigEventoUsuarioService } from '../../../../../auxiliares/servicios/http/config-evento-usuario.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { CardHeaderComponent } from '../../../../../componentes/card-header/card-header.component';
import { InfoBannerComponent } from '../../../../../componentes/info-banner/info-banner.component';

import { ContentCardComponent } from '../../../../../componentes/content-card/content-card.component';

@Component({
  selector: 'app-modo-estacionado',
  templateUrl: './modo-estacionado.component.html',
  styleUrls: ['./modo-estacionado.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    BOTONES,
    MatIconModule,
    NgSelectModule,
    CardHeaderComponent,
    InfoBannerComponent,
    ContentCardComponent,
  ],
})
export class ModoEstacionadoComponent implements OnInit, OnDestroy {
  dialogData = inject<{
    activo: IActivo;
  }>(MAT_DIALOG_DATA, { optional: true });
  dialogRef = inject<MatDialogRef<ModoEstacionadoComponent>>(MatDialogRef, {
    optional: true,
  });
  private service = inject(ConfigEventoUsuarioService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  route = inject(ActivatedRoute);

  public loading = false;
  public form?: FormGroup;
  public height = 'unset';
  public maxHeight = 'unset';

  // Datos de input al componente
  @Input() public edit?: IConfigEventoUsuario;
  @Input() public idEntidad?: string;

  public usuarios: IUsuario[] = [];

  // Listado Continuo
  public usuarios$?: Subscription;

  get estacionadoForm() {
    return this.form
      ?.get('condicion')
      ?.get('activo')
      ?.get('estacionado') as FormGroup;
  }

  private createForm(): void {
    const condicion = new FormGroup({
      activo: new FormGroup({
        estacionado: new FormGroup({
          ubicacionEstacionado: new FormControl(),
          distanciaDeAviso: new FormControl(50),
        }),
      }),
    });

    this.form = new FormGroup({
      activa: new FormControl(false),
      tipoEnvio: new FormControl('Notificacion Push'),
      tipoEntidad: new FormControl('Activo'),
      idCategoriaEvento: new FormControl(null),
      condicion,
      agrupacion: new FormControl('Entidad'),
      idEntidad: new FormControl(
        this.idEntidad || this.dialogData?.activo?._id,
      ),
      idsUsuarios: new FormControl(),
      generarSoloUnaVez: new FormControl(true),
      notificar: new FormControl(true),
      atender: new FormControl(true),
    });
  }

  //
  public volver(res?: any) {
    if (this.dialogRef) {
      this.dialogRef.close(res);
    } else {
      HelperService.volver();
    }
  }

  public searchUsuario = (term: string, item: IUsuario) => {
    if (item.usuario?.toLowerCase().includes(term.toLowerCase())) return true;
    if (
      item.datosPersonales?.nombre?.toLowerCase().includes(term.toLowerCase())
    )
      return true;
    if (
      item.datosPersonales?.telefono?.toLowerCase().includes(term.toLowerCase())
    )
      return true;
    if (item.datosPersonales?.email?.toLowerCase().includes(term.toLowerCase()))
      return true;
    return false;
  };

  // Listados

  private async listarUsuarios(): Promise<void> {
    const query: IQueryParam = {
      select: 'usuario datosPersonales.telefono permisos',
      sort: 'usuario',
    };
    this.usuarios$?.unsubscribe();
    this.usuarios$ = this.lista2.usuarios(query).subscribe((data) => {
      this.usuarios = data.datos;
    });
  }

  private async listarConfigEventoUsuario(): Promise<void> {
    if (this.idEntidad || this.dialogData?.activo?._id) {
      const id = this.idEntidad || this.dialogData?.activo?._id;
      const filter: IFilter<IConfigEventoUsuario> = {
        idEntidad: id,
        'condicion.activo.estacionado': { $exists: true },
      } as any;
      const query: IQueryParam = { filter: JSON.stringify(filter) };
      const data = await firstValueFrom(this.lista2.configEventos(query));
      const existe = data.datos[0];
      if (existe) {
        this.edit = existe;
        this.estacionadoForm.patchValue({
          distanciaDeAviso:
            this.edit?.condicion?.activo?.estacionado?.distanciaDeAviso,
        });
        this.form.patchValue({ activa: this.edit?.activa });
        this.form.patchValue({
          idCategoriaEvento: this.edit?.idCategoriaEvento,
        });
        this.form.patchValue({ idEntidad: this.edit?.idEntidad });
        this.form.patchValue({ idsUsuarios: this.edit?.idsUsuarios });
      }
    }
  }

  private async ultimoReporteUbicacion(id: string): Promise<IGeoJSONPoint> {
    const filter: IFilter<IReporteGenerico> = {
      idsAsignados: id,
    };
    const query: IQueryParam = { filter: JSON.stringify(filter) };
    const data = await firstValueFrom(
      this.lista2.ultimosReportesGenericos<'Tracker 4G'>(query),
    );
    const reporte = data.datos.find((r) => this.helper.getValores(r)?.geojson);
    return reporte ? this.helper.getValores(reporte).geojson : null;
  }
  //
  public async onSubmit(): Promise<void> {
    this.loading = true;
    try {
      // Las configs de modo estacionado no se reactivan: al finalizar se
      // borran y al iniciar se crea una nueva (el backend borra las previas).
      // trackers-go dispara como máximo un evento por config.
      if (this.form?.value?.activa) {
        if (this.edit?._id) await this.service.delete(this.edit._id);
        this.helper.notifSuccess('Modo Estacionamiento Finalizado');
        this.volver();
        return;
      }
      const data: ICreateConfigEventoUsuario = this.form?.value;
      data.activa = true;
      data.condicion.activo.estacionado.ubicacionEstacionado =
        await this.ultimoReporteUbicacion(data.idEntidad);
      if (!data.condicion.activo.estacionado.ubicacionEstacionado) {
        this.helper.notifWarn('El vehículo no tiene ningún reporte');
        this.volver();
        return;
      }
      const res = await this.service.create(data);
      this.helper.notifSuccess('Modo Estacionamiento Iniciado');
      this.volver(res);
    } catch (err) {
      console.error(err);
      this.helper.notifError(err);
    }
    this.loading = false;
  }
  //

  async ngOnInit(): Promise<void> {
    this.createForm();
    await this.listarConfigEventoUsuario();
    await this.listarUsuarios();
  }

  ngOnDestroy(): void {
    this.usuarios$?.unsubscribe();
  }
}
